import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductNotify extends HTMLElement {

  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.updateNotification);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateNotification);
  }

  updateNotification = (event) => {

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } 
    else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newNotification = event.detail.data.html.querySelector('product-notify');

   

    if (!newNotification) return;

    morph(this, newNotification, { childrenOnly: true });
  };

}

if (!customElements.get('product-notify')) {
  customElements.define('product-notify', ProductNotify);
}